import { useRecoilValue } from 'recoil';
import WorkspaceDarkLogoSVG from '~/assets/workspace-logo-dark.svg';
import WorkspaceLightLogoSVG from '~/assets/workspace-logo-light.svg';
import { themeState } from '~/state/atoms/themeAtoms';

export default function WorkspaceLogo({ height = 64 }: { height?: number }) {
    const theme = useRecoilValue(themeState);
    return (
        <img
            src={
                theme === 'dark' ? WorkspaceLightLogoSVG : WorkspaceDarkLogoSVG
            }
            alt="Workspace Logo"
            width="auto"
            height={height}
            style={{ pointerEvents: 'none' }}
        />
    );
}
